import '../utilities/scrollIntoViewIfNeeded.js';
import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, createElement, Fragment } from 'react';
import '../utilities/ellipsis.js';
import { a as _objectSpread2, _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import { ErrorLabel } from '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import '../TextInput/TextInput.js';
import '../InputAddon/InputAddon.js';
import 'react-select';
import '../SelectInput/Control.js';
import '../SelectInput/ValueContainer.js';
import '../SelectInput/IndicatorsContainer.js';
import '../SelectInput/DropdownIndicator.js';
import '../SelectInput/ClearIndicator.js';
import '../SelectInput/Menu.js';
import '../SelectInput/SelectInput.js';
import PhoneInput from 'react-phone-number-input';
import PhoneNumberInputField from './PhoneNumberInputField.js';
import 'react-phone-number-input/flags';
import CountrySelect from './CountrySelect.js';
import { K as getInputLabelWithExample } from '../utils-58679d3d.js';
import 'react-phone-number-input/input';

const PhoneNumberInputRoot = styled(Div).attrs(props => _objectSpread2({
  width: '100%',
  position: 'relative'
}, props))``;

const _excluded = ["defaultCountry", "label", "styles", "onCountryChange", "numberInputProps", "countrySelectProps", "onChange", "disabled", "error", "showExamplePhoneNumber"];
const PhoneNumberInput = _ref => {
  var _styles$input, _styles$input2, _styles$input3;
  let {
      defaultCountry = 'US',
      label = '',
      styles = {},
      onCountryChange,
      numberInputProps,
      countrySelectProps,
      onChange,
      disabled,
      error,
      showExamplePhoneNumber = true
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [country, setCountry] = useState(defaultCountry);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(PhoneInput, _extends({
    onChange: onChange,
    disabled: disabled,
    defaultCountry: defaultCountry,
    inputComponent: PhoneNumberInputField,
    onCountryChange: newCountry => {
      if (newCountry) {
        setCountry(newCountry);
      }
      onCountryChange === null || onCountryChange === void 0 ? void 0 : onCountryChange(newCountry);
    },
    numberInputProps: _objectSpread2({
      styles: {
        input: _objectSpread2({
          pl: '100px',
          error
        }, (_styles$input = styles.input) === null || _styles$input === void 0 ? void 0 : _styles$input.input),
        label: _objectSpread2({
          pl: '100px'
        }, (_styles$input2 = styles.input) === null || _styles$input2 === void 0 ? void 0 : _styles$input2.label),
        root: (_styles$input3 = styles.input) === null || _styles$input3 === void 0 ? void 0 : _styles$input3.root
      },
      label: getInputLabelWithExample(label, country, showExamplePhoneNumber)
    }, numberInputProps),
    countrySelectComponent: CountrySelect,
    containerComponent: PhoneNumberInputRoot,
    countrySelectProps: _objectSpread2({
      styles: styles.countrySelect,
      disabled
    }, countrySelectProps),
    style: styles.root
  }, rest)), error && /*#__PURE__*/createElement(ErrorLabel, null, error.errorMessage));
};

export default PhoneNumberInput;
